import { render, staticRenderFns } from "./PublicRegisterModal.vue?vue&type=template&id=2bdfdd3e&lang=html&"
import script from "./PublicRegisterModal.vue?vue&type=script&lang=js&"
export * from "./PublicRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./PublicRegisterModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports